<template>
  <v-card class="app-background-color">
    <v-card-title>ماشین حساب</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-data-table
            :headers="packageHeaders"
            :items="packages"
            class="elevation-1"
            item-key="name"
            show-select
            :single-select="true"
            hide-default-footer
            hide-default-header
            disable-sort
            @input="setPackage"
          >
            <template #header>
              <tr>
                <th
                  colspan="2"
                  class="indigo white--text pa-3"
                  style="border-bottom: 1px dashed #212121"
                >انتخاب بسته</th>
              </tr>
            </template>
          </v-data-table>
        </v-col>
        <v-col cols="12" md="4">
          <v-data-table
            :headers="modulesHeaders"
            :items="modules"
            class="elevation-1"
            item-key="codename"
            show-select
            v-model="package.modules"
            hide-default-footer
            hide-default-header
            disable-sort
            :return-object="false"
          >
            <template #header>
              <tr>
                <th colspan="3" class="pa-3 header-border">ماژول ها</th>
              </tr>
            </template>
            <template #item.price="{ item }">{{ item.price | toMoney }}</template>
          </v-data-table>
        </v-col>
        <v-col cols="12" md="4">
          <v-row class="ma-0 ">
            <v-col cols="12" class="elevation-1 white">
              <v-row class="d-flex flex-row align-center header-border">
                <v-col cols="3">
                  <span class="font-weight-bold grey--text text--darken-4">تعداد شرکت ها</span>
                </v-col>
                <v-col>
                  <v-slider
                    class="mt-12"
                    v-model="package.companies"
                    thumb-label="always"
                    min="1"
                    max="10"
                  />
                </v-col>
              </v-row>

              <v-row class="d-flex flex-row align-center">
                <v-col cols="3">
                  <span class="font-weight-bold grey--text text--darken-4">تعداد کاربر ها</span>
                </v-col>
                <v-col>
                  <v-slider
                    class="mt-12"
                    v-model="package.users"
                    thumb-label="always"
                    min="1"
                    max="10"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="elevation-1 pb-1 mt-3 grey lighten-4 grey--text text--darken-4">
              <v-row>
                <template v-for="(price, i) in prices">
                  <v-col :key="'1' + i" cols="9" class="py-1">{{ price.title }}</v-col>
                  <v-col :key="'2' + i" cols="3" class="py-1 text-left">{{ price.price | toMoney }} ریال</v-col>
                </template>

                <v-col cols="6" class="mt-2 pt-4 text-h5 top-border">مبلغ قابل پرداخت</v-col>
                <v-col
                  cols="6"
                  class="mt-2 pt-4 text-h5 top-border text-left"
                >{{ payablePrice | toMoney }} ریال</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "Test",
  data() {
    return {
      package: {
        modules: [],
        users: 1,
        companies: 1,
        discount: 0,
      },
      packageHeaders: [
        {
          text: "نام",
          value: "name",
        },
      ],
      packages: [
        {
          name: "فروشگاهی",
          modules: ["transactions", "warehouses", "factors"],
          users: 1,
          companies: 1,
          discount: 5,
        },
        {
          name: "خدماتی",
          modules: ["sanads", "transactions", "factors"],
          users: 1,
          companies: 1,
          discount: 10,
        },
        {
          name: "بازرگانی",
          modules: ["sanads", "transactions", "warehouses", "factors"],
          users: 1,
          companies: 1,
          discount: 15,
        },
      ],
      modulesHeaders: [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "قیمت",
          value: "price",
          align: "left",
        },
      ],
      modules: [
        {
          name: "حسابداری",
          codename: "sanads",
          price: 1700000,
        },
        {
          name: "خزانه داری",
          codename: "transactions",
          price: 1200000,
        },
        {
          name: "انبار",
          codename: "warehouses",
          price: 900000,
        },
        {
          name: "بازرگانی",
          codename: "factors",
          price: 2000000,
        },
      ],
      userFee: 350000,
      companyFee: 500000,
    };
  },
  computed: {
    payablePrice() {
      return this.prices.reduce((v, o) => {
        if (o.adds) return v + o.price;
        else return v - o.price;
      }, 0);
    },
    prices() {
      let totalSum = this.package.modules.reduce((v, o) => v + +o.price, 0);
      let discount = this.package.discount * totalSum;
      if (discount) discount /= 100;
      return [
        {
          title: "جمع کل",
          price: totalSum,
          adds: true,
        },
        {
          title: "جمع تعداد کاربران اضافی",
          price: this.userFee * (this.package.users - 1),
          adds: true,
        },
        {
          title: "جمع تعداد شرکت های اضافی",
          price: this.companyFee * (this.package.companies - 1),
          adds: true,
        },
        {
          title: "تخفیف",
          price: discount,
          adds: false,
        },
        {
          title: "مالیات بر ارزش افزوده",
          price: 0.09 * (totalSum - discount),
          adds: true,
        },
      ];
    },
  },
  created() {
    this.packages.forEach((p) => {
      p.modules = this.modules.filter((o) => p.modules.includes(o.codename));
    });
  },
  methods: {
    setPackage(item) {
      this.package = item[0];
    },
  },
};
</script>

<style scoped lang="scss">
.header-border {
  border-bottom: 1px dashed #212121 !important;
}
.top-border {
  border-top: 1px dashed #212121 !important;
}
</style>
